import FeeTableValue from './FeeTableValue';
import md5 from 'md5';

export default class FeeTable {

    static clone(feeTableToClone) {

        let feeTable = new FeeTable();
        feeTable.id = null;
        feeTable.start = feeTableToClone.start;
        feeTable.values = feeTableToClone.values.map(feeTableValue => FeeTableValue.clone(feeTableValue));
        feeTable.hash = md5(JSON.stringify(feeTable));

        return feeTable;
    }

    static init() {

        let feeTable = new FeeTable();
        feeTable.id = null;
        feeTable.start = {
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
        };
        feeTable.values = [FeeTableValue.init('EUR')];

        return feeTable;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let feeTable = new FeeTable();
        feeTable.id = data.id;
        feeTable.start = {
            month: new Date(data.start).getMonth() + 1,
            year: new Date(data.start).getFullYear(),
        };
        feeTable.values = data.values.data.map(value => FeeTableValue.fromData(value));
        feeTable.hash = md5(JSON.stringify(feeTable))

        return feeTable;
    }

    toData() {

        let month = '0' + this.start.month;
        month = month.substr(month.length - 2);
        let start = this.start.year + '-' + month + '-01';
        return {
            id: this.id,
            start: start,
            values: this.values.map(value => FeeTableValue.toData(value)),
        }
    }

    hasChanged() {
        const initialHash = this.hash;
        delete this.hash;
        const currentHash = md5(JSON.stringify(this));
        const hasChanged =  initialHash !== currentHash
        this.hash = initialHash;

        return hasChanged;
    }
}
